import React from "react";
import ReactDOM from "react-dom/client";
import { Layout } from "@/layout.jsx";
import * as Sentry from "@sentry/react";

const el = document.getElementById("react-app");

if (window.sentryDsn && !window.location.hostname.includes("localhost")) {
  Sentry.init({
    dsn: window.sentryDsn,
    environment: "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: true,
    ignoreErrors: [
      "Checkout payment error: You already bought the same product today",
      "Checkout payment error: Customer is blacklisted",
      /^Checkout payment error: Transaction Declined: \d+ - .+$/,
    ],
  });
}

if (el) {
  ReactDOM.createRoot(el).render(
    // <DevSupport ComponentPreviews={ComponentPreviews} useInitialHook={useInitial}>
    <Layout />
    // </DevSupport>
  );
}
